export default {
  text: 'Vous avez gagné {{points}} points ({{amount}}) sur cette commande',
  button: 'Se connecter et réclamer les points',
};
